module.exports = __webpack_public_path__ + "static/media/sourcesanspro-italic-webfont.1c766c2a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/sourcesanspro-italic-webfont.woff
// module id = 276
// module chunks = 0